import { useGetMyPermissionsQuery } from "@/api/GetMyPermissions/GetMyPermissionsApiSlice";
import { useSelector } from "react-redux";
import { notAuthenticatedUserId, userSelector } from "@/features/Auth/CurrentUser/Slice/CurrentUserSlice";

export const usePermissions = () => {
    const user = useSelector(userSelector);

    const {data: permissions = [], isLoading} = useGetMyPermissionsQuery(undefined, {
        skip: user.id === notAuthenticatedUserId,
    });

    const hasPermission = (permission: string | string[]): boolean => {
        if (!permissions || permissions.length === 0) return false;

        if (Array.isArray(permission)) {
            // Проверяем, есть ли хотя бы одно из разрешений
            return permission.some(perm => permissions.includes(perm));
        }

        return permissions.includes(permission);
    };

    const hasAllPermissions = (requiredPermissions: string[]): boolean => {
        if (!permissions || permissions.length === 0) return false;
        return requiredPermissions.every(perm => permissions.includes(perm));
    };

    return {
        permissions,
        isLoading,
        hasPermission,
        hasAllPermissions,
    };
};
